import { useContext } from 'react';
import { RbacContext, RbacContextValue } from './RbacContext';

const useRbac = (): RbacContextValue => {
  return useContext(RbacContext);
};

export default useRbac;
